import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const isProduction = process.env.NODE_ENV === "production";

const requiredEnvVars = [
  "REACT_APP_FIREBASE_API_KEY",
  "REACT_APP_FIREBASE_AUTH_DOMAIN",
  "REACT_APP_FIREBASE_PROJECT_ID",
  "REACT_APP_FIREBASE_STORAGE_BUCKET",
  "REACT_APP_FIREBASE_MESSAGING_SENDER_ID",
  "REACT_APP_FIREBASE_APP_ID",
] as const;

function getConfig() {
  if (isProduction) {
    const missing = requiredEnvVars.filter(
      (key) => !process.env[key] || process.env[key]?.trim() === "",
    );
    if (missing.length > 0) {
      throw new Error(
        `NomNom Admin: missing required env in production: ${missing.join(", ")}. ` +
          "Set these in your build environment (e.g. Vercel, Netlify) or .env.production.",
      );
    }
  }

  return {
    apiKey:
      process.env.REACT_APP_FIREBASE_API_KEY ||
      "AIzaSyBzDI1uOo0NHGwb5Lguv00V25J6kIdzz2Q",
    authDomain:
      process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
      "nomnom-app-prod.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "nomnom-app-prod",
    storageBucket:
      process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
      "nomnom-app-prod-storage",
    messagingSenderId:
      process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "919028648871",
    appId:
      process.env.REACT_APP_FIREBASE_APP_ID ||
      "1:919028648871:web:dce77eac88a2df8e294482",
  };
}

export const firebaseConfig = getConfig();

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app;
